import {CustomError} from '../../../libs/shared/helpers/src/types/customErrors';
import {CancelToken} from '../../helpers/asyncCancelHelpers';
import {IncidentModel} from '../../models/api/incidentModel';

export interface IncidentsConnector {
  fetchIncidentsAsync(cancelToken: CancelToken): Promise<ReadonlyArray<IncidentModel>>;
}

/** Thrown if the incidents could not be fetched, such as due to a network or other I/O error. */
export class IncidentsUnavailableError extends CustomError {}
